'use strict';

var win;

if (typeof window !== 'undefined') {
  win = window;
} else if (typeof global !== 'undefined') {
  win = global;
} else if (typeof self !== 'undefined') {
  win = self;
} else {
  win = {};
}

module.exports = win;


//////////////////
// WEBPACK FOOTER
// ./~/react-infinite/build/utils/window.js
// module id = 670
// module chunks = 0